export interface IGroup {
  id?: number;
  name?: string;
  description?: string | null;
}

export const defaultValue: Readonly<IGroup> = {};
